import React, { Component } from "react";
import { Nav, Navbar, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import navbarLogo from "../resources/image/navbar_logo.png";
import { connect } from "react-redux";
import { getProfile, terminateSession } from "../network/api";
import { updateProfile } from "../redux/actions";
import { bindActionCreators } from "redux";
import { logout, getSessionKeyId } from "../authentication/authorizer";
import ModalLogout from "../components/util/modal-yes-or-no";
import { logout_from_account, logout_from_account_description } from "../resources/string/strings"
import { withRouter } from 'react-router-dom';
import { ReactComponent as IconBack } from "../resources/image/ic_back.svg";

class NavBar extends Component {

  state = {
    logoutModalShow: false,
    navExpanded: false
  };

  componentDidMount() {
    setTimeout(
      function () {
        if (this.props.login.isLogin === "true") {
          this.callProfileApi();
        }
      }
        .bind(this),
      1000
    );


  }


  render() {
    var selectedItem = this.props.sideMenu.selectedItem
    var toolbarTitle = this.props.toolbar.title
    var permissions = this.props.profile.clientPermissions

    return (
      <Navbar
        className="toolbar shadow-sm"
        style={{
          paddingLeft: 5,
          background: "var(--colorPrimary)",
        }}
        collapseOnSelect
        sticky="top"
        expand="none"
        variant="dark"
        dir="ltr"
        onToggle={this.setNavExpanded}
        expanded={this.state.navExpanded}
      >
        <Container className="p-0">


          <Navbar.Brand >
            <div className="row p-0 mx-auto">
              {selectedItem !== "dashboard" && selectedItem !== "splash" &&
              <span className="col-1 mr-0">
               <IconBack
                  style={{ color: "white"}}
                  className=" p-0 clickable"
                  width="10"
                  height="32"
                  fill="white"
                  onClick={() =>{
                    if (this.props.history.length === 1 ){
                      window.close();
                    } else {
                      this.closeNav()
                      this.props.history.go(-1)
                    }
                  }
                  }
                />
              </span>
               
              }
              {selectedItem === "dashboard" &&
                <img
                  className="p-0 col-1"
                  alt="Weconsole"
                  src={navbarLogo}
                  style={{
                    width: 0,
                    height: 36,
                    marginTop: -2,
                    marginBottom: -2,
                  }}
                />
              }
              
            </div>

          </Navbar.Brand>


          {selectedItem !== undefined && selectedItem !== 0 && 
                <div
                  className="p-0"
                  style={selectedItem === "dashboard" ?
                   {color: "white",  fontSize: 17, textAlign: "right", float: "right" , marginLeft: 24} : 
                   {color: "white",  fontSize: 17, textAlign: "right", float: "right" }
                  }
                >
                  {toolbarTitle}

                </div>
            }

          <Navbar.Toggle
            style={{ border: 0, outline: "none", boxShadow: "none" }}
            aria-controls="responsive-navbar-nav"
          />


          <Navbar.Collapse
            id="responsive-navbar-nav"
          >
            <Nav style={{ paddingRight: 18 }} onSelect={this.closeNav}>

              <Link className={selectedItem !== "dashboard" ? "toolbar-item" : "toolbar-item-selected"} onClick={this.closeNav} to="/dashboard">
                داشبورد
              </Link>

              {permissions !== undefined && permissions["client_releases"] &&
                <Link className={selectedItem !== "releases" ? "toolbar-item" : "toolbar-item-selected"} onClick={this.closeNav} to="/releases">
                  ریلیزها
                </Link>
              }

              <Link className={selectedItem !== "profile" ? "toolbar-item" : "toolbar-item-selected"} onClick={this.closeNav} to="/profile">
                پروفایل
              </Link>

              <div className="toolbar-item" onClick={this.showLogoutModal} >
                خروج از حساب
              </div>

            </Nav>
          </Navbar.Collapse>

        </Container>

        <ModalLogout
          show={this.state.logoutModalShow}
          onHide={this.handleLogoutModalClose}
          title={logout_from_account}
          description={logout_from_account_description}
        />
      </Navbar>
    );
  }

  showLogoutModal = () => {
    this.setState({ logoutModalShow: true });
  };

  handleLogoutModalClose = (isYes) => {
    this.closeNav()
    this.setState({ logoutModalShow: false });
    if (isYes) {
      this.handleLogoutClick();
    }
  };

  handleLogoutClick = () => {
    this.callTerminateSessionApi()
  };

  setNavExpanded = (expanded) => {
    this.setState({ navExpanded: expanded });
  };

  closeNav = () => {
    this.setState({ navExpanded: false });
  };

  /****
  ** NETWORK
  *****/

  callProfileApi() {
    this.setState({ loading: true })
    getProfile(this.handleProfileApiSuccess, this.handleProfileApiFailure);
  }

  handleProfileApiSuccess = (data) => {
    this.setState({ loading: false });
    this.props.updateProfile(data)
  };

  handleProfileApiFailure = (error) => {
    this.setState({ loading: false });
  }

  callTerminateSessionApi = () => {
    terminateSession(getSessionKeyId(), this.handleTerminateSessionApiSuccess, this.handleTerminateSessionFailure);
  };

  handleTerminateSessionApiSuccess = (data) => {
    logout();
    window.location.reload();
  };

  handleTerminateSessionFailure = (error) => {
    logout();
    window.location.reload();
  };
}

//// REDUX STUFF
function mapStateToProps(state) {
  return {
    login: state.login,
    profile: state.profile.profile,
    sideMenu: state.sideMenu,
    toolbar: state.toolbar,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ updateProfile: updateProfile, }, dispatch);
}


export default connect(mapStateToProps, matchDispatchToProps)(withRouter(NavBar));
